// Currency conversion utilities

export const currencies = {
  GBP: { symbol: '£', name: 'British Pound', flag: '🇬🇧' },
  KWD: { symbol: 'KD', name: 'Kuwaiti Dinar', flag: '🇰🇼' },
  IQD: { symbol: 'IQD', name: 'Iraqi Dinar', flag: '🇮🇶' },
  SAR: { symbol: 'SAR', name: 'Saudi Riyal', flag: '🇸🇦' },
  AED: { symbol: 'AED', name: 'UAE Dirham', flag: '🇦🇪' }
};

// Exchange rates (as of 2025 - these should be fetched from API in production)
export const exchangeRates = {
  GBP: 1,
  KWD: 0.25,    // 1 GBP = 0.25 KWD
  IQD: 1650,    // 1 GBP = 1650 IQD
  SAR: 4.72,    // 1 GBP = 4.72 SAR
  AED: 4.62     // 1 GBP = 4.62 AED
};

export const convertCurrency = (amountInGBP, targetCurrency) => {
  if (!exchangeRates[targetCurrency]) {
    return amountInGBP;
  }
  return Math.round(amountInGBP * exchangeRates[targetCurrency]);
};

export const formatCurrency = (amount, currency = 'GBP') => {
  const currencyInfo = currencies[currency];
  if (!currencyInfo) return `£${amount.toLocaleString()}`;
  
  const converted = convertCurrency(amount, currency);
  
  if (currency === 'GBP') {
    return `${currencyInfo.symbol}${converted.toLocaleString()}`;
  }
  
  // For other currencies, show symbol after amount (Arabic style)
  return `${converted.toLocaleString()} ${currencyInfo.symbol}`;
};

export const getAllPrices = (amountInGBP) => {
  return Object.keys(currencies).reduce((acc, currency) => {
    acc[currency] = {
      amount: convertCurrency(amountInGBP, currency),
      formatted: formatCurrency(amountInGBP, currency),
      symbol: currencies[currency].symbol,
      flag: currencies[currency].flag
    };
    return acc;
  }, {});
};

export const getCurrencyFromBranch = (branchCountry) => {
  const countryToCurrency = {
    'United Kingdom': 'GBP',
    'Kuwait': 'KWD',
    'Iraq': 'IQD',
    'Saudi Arabia': 'SAR',
    'United Arab Emirates': 'AED'
  };
  return countryToCurrency[branchCountry] || 'GBP';
};
